// extracted by mini-css-extract-plugin
module.exports = {"message-box":"FatalBox_message-box__6TPcX","messageBox":"FatalBox_message-box__6TPcX","phone-number":"FatalBox_phone-number__0dt_L","phoneNumber":"FatalBox_phone-number__0dt_L"};